var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnpublish(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99965 6.17L5.48965 1.66C7.06965 0.61 8.95965 0 10.9996 0C16.5196 0 20.9996 4.48 20.9996 10C20.9996 12.04 20.3896 13.93 19.3396 15.51L17.8796 14.05C18.5896 12.87 18.9996 11.48 18.9996 10C18.9996 6.65 16.9296 3.78 13.9996 2.59V3C13.9996 4.1 13.0996 5 11.9996 5H9.99965V6.17ZM20.1896 19.19L18.7796 20.6L16.5096 18.33C14.9296 19.39 13.0396 20 10.9996 20C5.47965 20 0.999648 15.52 0.999648 10C0.999648 7.96 1.60965 6.07 2.65965 4.49L0.389648 2.22L1.79965 0.81L20.1896 19.19ZM9.99965 16C8.89965 16 7.99965 15.1 7.99965 14V13L3.20965 8.21C3.07965 8.79 2.99965 9.38 2.99965 10C2.99965 14.08 6.04965 17.44 9.99965 17.93V16Z",
    fill: "#FD8D8D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpublish);
export default __webpack_public_path__ + "static/media/unpublish.ad7b4495d9f3dcc98020a252ac508797.svg";
export { ForwardRef as ReactComponent };